import { createFileRoute } from '@tanstack/react-router'
import { Compare } from '@/components/home/compare'
import { Cta } from '@/components/home/cta'
import { Hero } from '@/components/home/hero'
import { MobileApps } from '@/components/home/mobile-apps'
import { MoreCoverage } from '@/components/home/more-coverage'
import { Pricing } from '@/components/home/pricing-section'
import { ProofStrip } from '@/components/home/proof-strip'
import { Story } from '@/components/home/story'
import { jsonLdScript, webPage } from '@/lib/schema'

// --- Route + SEO (preserved exactly) ---

export const Route = createFileRoute('/_site/')({
  component: HomePage,
  head: () => ({
    meta: [
      { title: 'Uptrack — Cheapest 30-second uptime monitoring' },
      { name: 'description', content: 'Know your website is down in seconds, not minutes. 30-second HTTP checks from up to 24 locations, plus browser checks for login and checkout.' },
      { property: 'og:title', content: 'Uptrack — Cheapest 30-second uptime monitoring' },
      { property: 'og:description', content: 'Know your website is down in seconds, not minutes. 30-second uptime checks from up to 24 locations, plus browser checks for login and checkout. Free plan with 5 monitors; paid from $3/month.' },
      { property: 'og:image', content: 'https://uptrack.app/og/home.png' },
      { property: 'og:url', content: 'https://uptrack.app' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
    links: [
      { rel: 'canonical', href: 'https://uptrack.app' },
    ],
    scripts: [
      jsonLdScript(webPage({
        name: 'Uptrack — Cheapest 30-second uptime monitoring',
        description: 'Know your website is down in seconds, not minutes. 30-second HTTP checks from up to 24 locations, plus browser checks for login and checkout.',
        url: 'https://uptrack.app',
      })),
    ],
  }),
})

// --- Page ---

// Hero, proof, the scroll story (browser checks, consensus, speed, alerts), the mobile apps and their video, then pricing.
function HomePage() {
  return (
    <>
      <Hero />
      <ProofStrip />
      <Story />
      <MobileApps />
      <Pricing />
      <MoreCoverage />
      <Compare />
      <Cta />
    </>
  )
}
